import { Flex } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

export interface ILecturePlayerPanelProps {
  isOpen: boolean;
  children: ReactNode;
}

export const LecturePlayerPanel: FC<ILecturePlayerPanelProps> = ({ children, isOpen, ...rest }) => (
  <Flex
    direction="column"
    data-expanded={isOpen ? 'true' : undefined}
    overflow="hidden"
    h={{ base: 0, md: 'full' }}
    w={{ base: 'full', md: 0 }}
    _expanded={{
      w: { base: 'full', md: '389px' },
      h: { base: '291px', md: 'full' },
    }}
    {...rest}
  >
    <Flex direction="column" w="full" h="full" pl={{ base: 0, md: 4 }}>
      {isOpen && children}
    </Flex>
  </Flex>
);
